import React, { createContext, useContext } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DraftDashboardChart } from 'libs/end-to-end/src/dashboard';

export const CHART_DRAG_TYPE = 'CHART_CARD';

export interface DragItem {
  id: string;
  chart: DraftDashboardChart;
}

export interface DropResult {
  targetId: string;
  position: 'before' | 'after';
}

interface DragDropContextValue {
  onMoveChart: (
    draggedChartDraftId: string,
    targetChartDraftId: string,
    position: 'top' | 'right' | 'bottom' | 'left',
  ) => Promise<void>;
}

const DragDropContext = createContext<DragDropContextValue | null>(null);

export const useDragDropContext = () => {
  const context = useContext(DragDropContext);
  if (!context) {
    throw new Error(
      'useDragDropContext must be used within a DragDropProvider',
    );
  }
  return context;
};

interface DragDropProviderProps {
  children: React.ReactNode;
  onMoveChart: (
    draggedChartDraftId: string,
    targetChartDraftId: string,
    position: 'top' | 'right' | 'bottom' | 'left',
  ) => Promise<void>;
}

export const DragDropProvider: React.FC<DragDropProviderProps> = ({
  children,
  onMoveChart,
}) => {
  return (
    <DndProvider backend={HTML5Backend}>
      <DragDropContext.Provider value={{ onMoveChart }}>
        {children}
      </DragDropContext.Provider>
    </DndProvider>
  );
};
